import {NgModule} from "@angular/core";
import {FilterPipe} from "./filter.pipe";

@NgModule({
  declarations: [
    FilterPipe,
  ],
  exports: [
    FilterPipe
  ],
  providers: [
    FilterPipe
  ]
})
export class FilterPipeModule {
}



// WEBPACK FOOTER //
// ./src/pipes/filter/filter.pipe.module.ts